import type { ImageGalleryComponent as ImageGalleryComponentType } from '../../schemas/validation';

export interface ImageGalleryComponentProps {
  component: ImageGalleryComponentType;
}

export type GalleryItem = ImageGalleryComponentType['data']['items'][number];

export interface GalleryColors {
  backgroundColor: string;
  textColor: string;
  titleColor: string;
  subtitleColor: string;
  captionColor: string;
  filterButtonColor: string;
  filterButtonActiveColor: string;
}

export interface ImageItemProps {
  item: GalleryItem;
  index: number;
  isMasonry?: boolean;
  lightboxEnabled: boolean;
  lazyLoading: boolean;
  captionPosition: string;
  aspectRatio: string;
  captionColor: string;
  imageRefs: React.MutableRefObject<(HTMLImageElement | null)[]>;
  onImageClick: (index: number) => void;
}

export interface LayoutProps {
  filteredItems: GalleryItem[];
  colors: GalleryColors;
  data: ImageGalleryComponentType['data'];
  imageRefs: React.MutableRefObject<(HTMLImageElement | null)[]>;
  onImageClick: (index: number) => void;
}

export interface LightboxProps {
  isOpen: boolean;
  currentIndex: number;
  items: GalleryItem[];
  onClose: () => void;
  onPrev: () => void;
  onNext: () => void;
}

export interface FilterButtonsProps {
  categories: string[];
  activeFilter: string;
  onFilterChange: (filter: string) => void;
  textColor: string;
  filterButtonColor: string;
  filterButtonActiveColor: string;
}

export const SPACING_CLASSES = {
  compact: 'gap-2 md:gap-3',
  normal: 'gap-4 md:gap-6',
  spacious: 'gap-6 md:gap-8',
} as const;

export const GRID_COLS = {
  1: 'grid-cols-1',
  2: 'grid-cols-1 md:grid-cols-2',
  3: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
  4: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4',
  5: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-5',
  6: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6',
} as const;
